module.exports = __webpack_public_path__ + "static/media/alipay.55914764.svg";